import { render, staticRenderFns } from "./BlockButtonsItem.vue?vue&type=template&id=0af731c2&scoped=true&"
import script from "./BlockButtonsItem.vue?vue&type=script&lang=ts&"
export * from "./BlockButtonsItem.vue?vue&type=script&lang=ts&"
import style0 from "./BlockButtonsItem.vue?vue&type=style&index=0&id=0af731c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af731c2",
  null
  
)

export default component.exports